import {createAction} from 'typesafe-actions';

import type * as PanelBankConfigTypes from '../panelBankConfig/types';
import type * as PanelBankSectionConfigTypes from '../panelBankSectionConfig/types';
import type * as WorkspaceSettingsTypes from '../workspaceSettings/types';
import type * as Types from './types';

export const setConfig = createAction(
  '@view/panel/setConfig',
  action => (ref: Types.Ref, config: Types.Panel['config'], key?: string) =>
    action({ref, config, key})
);

export const setConfigs = createAction(
  '@view/panel/setConfigs',
  action => (refs: Types.Ref[], configs: Array<Types.Panel['config']>) =>
    action({refs, configs})
);

/**
 * Updates the config of an individual panel.
 */
export const updateConfig = createAction(
  '@view/panel/updateConfig',
  action =>
    (
      ref: Types.Ref,
      configUpdate: Partial<Types.Panel['config']>,
      panelBankSectionConfigRef?: PanelBankSectionConfigTypes.Ref,
      options?: {isUndoable?: boolean}
    ) =>
      action({ref, configUpdate, panelBankSectionConfigRef, options})
);

export const updateConfigs = createAction(
  '@view/panel/updateConfigs',
  action => (refs: Types.Ref[], configUpdate: Partial<Types.Panel['config']>) =>
    action({refs, configUpdate})
);

export const deletePanels = createAction(
  '@view/panel/deletePanels',
  action =>
    (
      panelRefs: Types.Ref[],
      sectionRef?: PanelBankSectionConfigTypes.Ref,
      panelBankConfigRef?: PanelBankConfigTypes.Ref,
      workspaceSettingsRef?: WorkspaceSettingsTypes.Ref,
      isPanelsAutoForUndoRedo?: {value: boolean | undefined}
    ) =>
      action({
        panelRefs,
        sectionRef,
        panelBankConfigRef,
        workspaceSettingsRef,
        isPanelsAutoForUndoRedo,
      })
);

export const undoDeletePanels = createAction(
  '@view/panel/undoDeletePanels',
  action =>
    (
      deletePanelsResult: Types.DeletePanelsResult,
      sectionRef?: PanelBankSectionConfigTypes.Ref,
      panelBankConfigRef?: PanelBankConfigTypes.Ref,
      workspaceSettingsRef?: WorkspaceSettingsTypes.Ref,
      isPanelsAutoForRedo?: {value: boolean | undefined}
    ) =>
      action({
        deletePanelsResult,
        sectionRef,
        panelBankConfigRef,
        workspaceSettingsRef,
        isPanelsAutoForRedo,
      })
);
